import { RouteConfig } from 'vue-router';

import { confirmRoute } from './startRoute/confirm.route';
import { confirmDeleteRoute } from './startRoute/confirmDelete.route';
import { loginRoute } from './startRoute/login.route';
import { logoutRoute } from './startRoute/logout.route';
import { registerRoute } from './startRoute/register.route';
import { resetPasswordRoute } from './startRoute/resetPassword.route';
import { setPasswordRoute } from './startRoute/setPassword.route';
import { ssoLoginRoute } from './startRoute/ssoLogin.route';
import { updatePasswordRoute } from './startRoute/updatePassword.route';

export const startRoute: RouteConfig = {
  path: '/',
  component: () => import(/* webpackChunkName: "StartLayout" */ '@/layouts/StartLayout.vue'),
  children: [
    confirmRoute,
    loginRoute,
    logoutRoute,
    registerRoute,
    resetPasswordRoute,
    setPasswordRoute,
    ssoLoginRoute,
    confirmDeleteRoute,
    updatePasswordRoute
  ],
  redirect: { name: 'login' }
};
